import type { SVGProps } from "react";
import React from "react";
import { styled } from "@linaria/react";
import { color } from "../../ui";
import { fonts, spacings } from "../Theme";

interface P extends React.HtmlHTMLAttributes<HTMLDivElement> {
  title?: string;
  icon?: React.ReactElement<SVGProps<SVGSVGElement>>;
  children: React.ReactNode;

  style?: React.CSSProperties;
  className?: string;

  size?: "s" | "m";
  backgroundColor?: string;
  color?: string;
}

const BadgeWrapper = styled.div<P>`
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 100px;
  padding: 4px 8px;

  background-color: ${props =>
    props.backgroundColor ? props.backgroundColor : color.lightNitrogen50};
  color: ${props => (props.color ? props.color : color.lightNitrogen500_Main)};
  font: ${props => (props.size === "s" ? fonts.body3 : fonts.body2)};
  gap: ${props => (props.size === "s" ? spacings.xs : spacings.xxs)};
`;

const ChildrenWrapper = styled.span`
  margin: 0px;
  word-break: keep-all;
  white-space: nowrap;
`;

const Badge = ({ icon, children, ...rest }: P) => (
  <BadgeWrapper {...rest}>
    {icon}
    <ChildrenWrapper>{children}</ChildrenWrapper>
  </BadgeWrapper>
);

export default React.memo(Badge);
